<div *transloco="let t"
    class="transition-all duration-300 ease-out"
    [ngClass]="isClassyLayout
        ? 'px-[10px] w-full pt-3 pb-1'
        : 'flex flex-col justify-center items-center h-[64px] min-h-[64px] max-h-[64px] px-4'"
>
    <button
        (click)="navigateToDashboard()"
        class="transition-all group"
        style="transition-duration: 300ms; transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);"
        [ngClass]="isClassyLayout
            ? 'w-full rounded-lg flex items-center h-9 px-3 ' + (isActive() ? 'bg-[rgba(155,213,100,0.10)]' : 'hover:bg-[rgba(255,255,255,0.055)]')
            : 'flex items-center justify-center p-3 rounded ' + (isActive() ? 'bg-[rgba(155,213,100,0.10)]' : 'hover:bg-[rgba(255,255,255,0.055)]')"
    >
        <mat-icon [svgIcon]="'fluent:grid'"
            class="transition-all duration-300"
            [ngClass]="(isClassyLayout ? 'size-[18px] ' : 'size-6 ') + (isActive()
                ? 'text-[#9BD564]'
                : 'text-[rgba(255,255,255,0.38)] group-hover:text-[rgba(255,255,255,0.64)]')"
        ></mat-icon>
        <!-- Label — fades out in thin mode -->
        <span class="ml-2.5 text-[13px] transition-all duration-300 ease-out whitespace-nowrap overflow-hidden"
            style="letter-spacing: 0.01em;"
            [ngClass]="isClassyLayout
                ? 'opacity-100 max-w-[160px] ' + (isActive()
                    ? 'text-[rgba(255,255,255,0.92)] font-semibold'
                    : 'text-[rgba(255,255,255,0.64)] font-medium group-hover:text-[rgba(255,255,255,0.92)]')
                : 'opacity-0 max-w-0 ml-0'"
        >
            {{ t('sidebar.dashboard') }}
        </span>
    </button>
</div>
